import React from "react";
import { WEDDING } from "../utils/config";
export default function Footer() {
  return (
    <footer
      style={{
        background: "var(--deep)",
        borderTop: ".5px solid rgba(107,155,111,.18)",
        padding: "52px 36px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          fontFamily: "var(--font-serif)",
          fontStyle: "italic",
          fontSize: "32px",
          color: "#fff",
          marginBottom: "6px",
        }}
      >
        {WEDDING.groomName} & {WEDDING.brideName}
      </div>
      <div
        style={{
          fontSize: "8px",
          letterSpacing: ".26em",
          textTransform: "uppercase",
          color: "var(--gold)",
          marginBottom: "22px",
        }}
      >
        11–20 · September · 2026 · Serowe · Gaborone
      </div>
      <p
        style={{
          fontFamily: "var(--font-serif)",
          fontStyle: "italic",
          fontSize: "15px",
          color: "var(--sage-l)",
          maxWidth: "420px",
          margin: "0 auto 22px",
          lineHeight: 1.85,
        }}
      >
        "And over all these virtues put on love, which binds them all together
        in perfect unity."
        <cite
          style={{
            display: "block",
            fontStyle: "normal",
            fontFamily: "var(--font-sans)",
            fontSize: "8px",
            letterSpacing: ".15em",
            marginTop: "6px",
          }}
        >
          Colossians 3:14
        </cite>
      </p>
      <p
        style={{
          fontSize: "10px",
          color: "var(--muted)",
          letterSpacing: ".06em",
        }}
        ////Works offline once opened · Share the link or QR
      >
        {WEDDING.website}
        code
      </p>
    </footer>
  );
}
